import { batch, signal } from "@preact/signals-react"
import { getPreviousDate } from "@ui-seeker/utils"

export const retailersTrackedData = signal([])
export const retailersTrackedIsEmpty = signal(false)
export const retailersTrackedDate = signal(getPreviousDate({ days: 1 }))

export const resetRetailersTrackedSignals = () => batch(() => {
	retailersTrackedData.value = []
	retailersTrackedIsEmpty.value = false
	retailersTrackedDate.value = getPreviousDate({ days: 1 })
})
